import React,{Component} from 'react';

import {Link} from 'react-router-dom'

import _ from 'lodash'

import {
  Avatar,
  Card,
  Divider,
  ListItemText,
  ListItem,
  List,
} from 'material-ui'

import SectionTitle from './SectionTitle'

import {
  Accent,
  Primary,
  Purple,
  Green,
  LightGray,
} from '../helper/consts'

const colors = [Primary,Accent,Purple,Green,LightGray]

const style = {
  topJobsCard:{
    justifyContent: 'center',
    alignItems: 'center',
    // maxWidth: '540px',
    maxWidth: '33.3%',
  },
}

export default class AdminTopJobsCard extends Component{
  renderJobs=()=>{
    let html = [];
    const {jobs,countName} = this.props;
    jobs.forEach((job,i)=>{
      let item = (
        <ListItem key={job.jid} dense >
          <Avatar
            aria-label={job.company}
            style={{backgroundColor:colors[i]}}
          >
            {!!_.size(job[`${countName}`])?_.size(job[`${countName}`]):'0'}
          </Avatar>
            <ListItemText primary={<Link to={`/Offer/${job.oid}`}>{job.title} @ {job.company}</Link>} />
        </ListItem>
      )
      html.push(item)
      i<(jobs.length-1) && html.push(<Divider key={`${job.jid}_divider`} light />)
    })
    return html;
  }

  render(){
    return(
      <div className="dashboardCard" style={style.topJobsCard}>
        <SectionTitle title={this.props.title} />
        <Card className="card">
          <List>
            {this.renderJobs()}
        </List>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminTopJobsCard.js